import axios from 'axios';

export const axiosInterceptor = () => {
    axios.interceptors.request.use(
        config => {
            const token = localStorage.getItem('jwtToken');
            const expirationTime = localStorage.getItem('tokenExpiredTime');
            const currentTime = new Date();

            if (token && expirationTime) {
                const expirationDate = new Date(expirationTime);
                if (currentTime > expirationDate) {
                    localStorage.removeItem('jwtToken');
                    localStorage.removeItem('tokenExpiredTime');
                    window.location.href = '/';
                    return Promise.reject(new Error('Token expired'));
                }
                config.headers['Authorization'] = `Bearer ${token}`;
            }
            return config;
        },
        error => {
            return Promise.reject(error);
        }
    );

    axios.interceptors.response.use(
        response => {
            return response;
        },
        error => {
            if (error.response) {
                if (error.response.status === 401) {
                    console.error('Server error:', error.response);
                } else if (error.response.status === 500) {
                    console.error('Server error:', error.response);
                }
            }
            return Promise.reject(error);
        }
    );
};
